import * as Logger from "loglevel";

const infoStyle = "color: cyan;";
const errorStyle = "background-color: red; color: white";

const logger = {
  info: (msg: string, ...optionalParams: any[]) =>
    Logger.info(
      `%c [${new Date().toISOString()}] ${msg}`,
      infoStyle,
      ...optionalParams
    ),
  error: (msg: string, ...optionalParams: any[]) =>
    Logger.error(
      `%c [${new Date().toISOString()}] ${msg}`,
      errorStyle,
      ...optionalParams
    ),
};

export default logger;
